"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _AVNURAH2cjs = require('./AVNURAH2.cjs');


var _MLKK6UGOcjs = require('./MLKK6UGO.cjs');


var _EV33XSIBcjs = require('./EV33XSIB.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/tab/tab-store.ts
var _tabstore = require('@ariakit/core/tab/tab-store'); var Core = _interopRequireWildcard(_tabstore);
var _react = require('react');
function useTabStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.composite, props.combobox]);
  store = _MLKK6UGOcjs.useCompositeStoreProps.call(void 0, store, update, props);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "selectedId", "setSelectedId");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "selectOnMove");
  const [panels, updatePanels] = _FH6HQ5JNcjs.useStore.call(void 0, () => store.panels, {});
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, updatePanels, [store, updatePanels]);
  return Object.assign(
    _react.useMemo.call(void 0, () => ({ ...store, panels }), [store, panels]),
    { composite: props.composite, combobox: props.combobox }
  );
}
function useTabStore(props = {}) {
  const combobox = _EV33XSIBcjs.useComboboxContext.call(void 0, );
  const composite = _AVNURAH2cjs.useSelectContext.call(void 0, ) || combobox;
  props = {
    ...props,
    composite: props.composite !== void 0 ? props.composite : composite,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  };
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createTabStore, props);
  return useTabStoreProps(store, update, props);
}




exports.useTabStoreProps = useTabStoreProps; exports.useTabStore = useTabStore;
